import React from "react";
import "./LeftSide.scss";

const LeftSide = () => {
  return <div className="left"></div>;
};

export default LeftSide;
